import React, { createContext, useState, useEffect, useContext } from "react";
import { customFetch } from '../apiClient';

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
  const DEFAULT_COLOR = "#3E7198";
  // const DEFAULT_COLOR = "#0088cc";
   
   // ✅ Hardcoded Default Blue

  // 1. Current UI Color (Preview ke liye - Jo abhi dikh raha hai)
  const [themeColor, setThemeColor] = useState(() => {
    return sessionStorage.getItem("appThemeColor") || DEFAULT_COLOR;
  });

  // 2. Saved DB Color (Asli color jo Database me hai - Backup ke liye)
  const [savedDbColor, setSavedDbColor] = useState(DEFAULT_COLOR);

 

  // ✅ LOAD FROM DB (Initial Sync on Page Load)
  useEffect(() => {
    const syncThemeWithDB = async () => {
      const loginId = sessionStorage.getItem("loginId");
      const hid = sessionStorage.getItem("hospitalId");
      const token = sessionStorage.getItem("token");

      if (loginId && hid && token) {
        try {
         const response = await customFetch(`/hospitals/${hid}/users/${loginId}`);
          
          if (response.ok) {
            const data = await response.json();
            if (data.themeColor) {
              setThemeColor(data.themeColor);      // UI update
              setSavedDbColor(data.themeColor);    // Backup set karo
              sessionStorage.setItem("appThemeColor", data.themeColor);
            }
          }
        } catch (error) {
          console.error("Failed to sync theme", error);
        }
      }
    };
    syncThemeWithDB();
    // eslint-disable-next-line
  }, []);

  // ✅ CSS Variables Update (Preview Logic)
  useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty("--theme-color", themeColor);
    const darkColor = adjustBrightness(themeColor, -20);
    root.style.setProperty("--theme-color-dark", darkColor);
  }, [themeColor]);

  // -----------------------------------------------------------
  // ✅ 1. PREVIEW ONLY (Input change hone par chalega)
  // -----------------------------------------------------------
  const previewTheme = (newColor) => {
    setThemeColor(newColor); 
    // Note: Hum yahan DB call nahi kar rahe, bas state badal rahe hain
  };

  // -----------------------------------------------------------
  // ✅ 2. APPLY TO DB (Green Check Button dabane par)
  // -----------------------------------------------------------
  const applyThemeToDB = async () => {
    const loginId = sessionStorage.getItem("loginId");
    const hid = sessionStorage.getItem("hospitalId");

    if (loginId && hid) {
      try {
       await customFetch(`/hospitals/${hid}/users/${loginId}/theme`, {
  method: "PUT",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify(themeColor)
});
        // Success: Ab saved color bhi wahi ban gaya
        setSavedDbColor(themeColor); 
        sessionStorage.setItem("appThemeColor", themeColor);
        return true; 
      } catch (error) {
        console.error("Save failed", error);
        return false;
      }
    }
  };

  // -----------------------------------------------------------
  // ✅ 3. CANCEL / REVERT (Red Cross Button dabane par)
  // -----------------------------------------------------------
  const cancelChanges = () => {
    setThemeColor(savedDbColor); // Wapas purane DB color par le jao
  };

  // -----------------------------------------------------------
  // ✅ 4. RESET TO DEFAULT BLUE (Reset Button dabane par)
  // -----------------------------------------------------------
  const resetTheme = async () => {
    const loginId = sessionStorage.getItem("loginId");
    const hid = sessionStorage.getItem("hospitalId");
    
    // UI ko turant Blue karo
    setThemeColor(DEFAULT_COLOR);
    setSavedDbColor(DEFAULT_COLOR); // Backup bhi Blue banalo
    sessionStorage.setItem("appThemeColor", DEFAULT_COLOR);

    // DB me bhi Blue update karo (Force Update)
    if (loginId && hid) {
      try {
       await customFetch(`/hospitals/${hid}/users/${loginId}/theme`, {
  method: "PUT",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify(DEFAULT_COLOR)
});
      } catch (error) {
        console.error("Reset failed", error);
      }
    }
  };

  // Helper: Brightness
  function adjustBrightness(col, amt) {
    let usePound = false;
    if (col[0] === "#") { col = col.slice(1); usePound = true; }
    let num = parseInt(col, 16);
    let r = (num >> 16) + amt;
    if (r > 255) r = 255; else if (r < 0) r = 0;
    let b = ((num >> 8) & 0x00FF) + amt;
    if (b > 255) b = 255; else if (b < 0) b = 0;
    let g = (num & 0x0000FF) + amt;
    if (g > 255) g = 255; else if (g < 0) g = 0;
    return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);
  }

  return (
    <ThemeContext.Provider value={{ 
      themeColor, 
      savedDbColor,       
      previewTheme,    // Sirf UI Change ke liye
      applyThemeToDB,  // DB Save ke liye
      cancelChanges,   // Undo ke liye
      resetTheme       // Default Blue ke liye
    }}>
      {children}
    </ThemeContext.Provider>
  );
};